import React from "react";
import Context from "../../../Context";

export default class ManualFam extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      pending: false,
      result: {},
    };
  }
  componentDidMount() {
    this.load();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.itemId !== this.props.itemId) {
      this.load();
    }
  }
  load = async () => {
    this.setState({ pending: true });
    let result = await this.context.api.q("/familiarization/get", {
      content: this.props.itemId,
      staff: this.context.user.staffId || this.context.api.nullUuid,
    });
    this.setState({ pending: false, result });
  };
  sign = async () => {
    let promptResult = await this.context.promptPassword();
    let password = promptResult.value;
    if (password) {
      this.setState({ pending: true });
      let result = await this.context.api.q("/familiarization/sign", {
        content: this.props.itemId,
        staff: this.context.user.staffId || this.context.api.nullUuid,
        password,
      });

      if (result !== false) {
        if (this.props.onAfterFamiliarize) {
          this.props.onAfterFamiliarize();
        }
        this.load();
      } else {
        this.setState({ pending: false });
        this.context.toast("Не удалось подтвердить ознакомление", "error");
      }
    }
  };
  render() {
    if (this.state.pending) {
      return (
        <div className="d-inline-flex">
          <div className="spinner-border text-muted spinner-border-sm"></div>
        </div>
      );
    }
    return (
      <>
        {this.state.result.sign && <div className="familiar">Ознакомлен</div>}
        {!this.state.result.sign && (
          <>
            <button className="btn btn-warning" onClick={this.sign}>
              Ознакомиться
            </button>
          </>
        )}
      </>
    );
  }
}
